import { useContext } from 'react'

import { digObject } from '@domain-group/javascript-utils'

import { Button, ModalContext, SidebarModal } from '@domain-group/suit-theme'

import BrowseComparable from './components/BrowseComparable'
import ManuallyAddComparable from './components/ManuallyAddComparable'
import SearchComparables from './components/SearchComparables'

const MODAL_KEY = 'AddCampaignComparableModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const AddCampaignComparableModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { campaignComparable } = modalPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Add" titleSecondLine="Comparable" />

      <SidebarModal.Content boxProps={{ flexDirection: 'column' }}>
        <SearchComparables campaignComparable={campaignComparable} />

        <BrowseComparable campaignComparable={campaignComparable} />

        <ManuallyAddComparable campaignComparable={campaignComparable} />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryUtility"
          onClick={() => closeModal()}
          size="large"
        >
          Close
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <AddCampaignComparableModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
